import Grid from "@mui/material/Grid2";

export default function GridSection({ columnSize, children }) {
  return (
    <>
      <Grid size={Number(columnSize)}>{children}</Grid>
    </>
  );
}
